import { Animator } from './animator';

export class ObjectAnimator extends Animator {
    constructor(object: any, animationData: any) {
      super([object], animationData);
    }

}

/**
 * An Animator class for animating Object3D's based on an AnimationData.
 *
 * @constructor
 * @param {THREE.Object3D} object
 * The object to animate.
 * @param {AnimationData} animationData
 * The AnimationData to animate the geometry with.
 */


